"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalFloatingBehaviorSchema = exports.SignalFloatingBehavior = void 0;
const z = require("zod");
var SignalFloatingBehavior;
(function (SignalFloatingBehavior) {
    SignalFloatingBehavior["Always"] = "always";
    SignalFloatingBehavior["Sometimes"] = "sometimes";
    SignalFloatingBehavior["Never"] = "never";
    SignalFloatingBehavior["Unspecified"] = "unspecified";
    SignalFloatingBehavior["Conditional"] = "conditional";
})(SignalFloatingBehavior || (exports.SignalFloatingBehavior = SignalFloatingBehavior = {}));
exports.SignalFloatingBehaviorSchema = z.nativeEnum(SignalFloatingBehavior);
//# sourceMappingURL=SignalFloatingBehavior.js.map